import _regeneratorRuntime from "/home/runner/work/ami/ami/jaenjs/templates/jaen-template-shopify/node_modules/@babel/runtime/regenerator/index.js";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { KeyManager } from './keyManager.js';
export var SnekApi = /*#__PURE__*/function () {
  function SnekApi(url, options) {
    _classCallCheck(this, SnekApi);

    _defineProperty(this, "KeyManager", KeyManager);

    this.url = url.replace(/\/$/, '');
    this.options = options || {};
  }

  _createClass(SnekApi, [{
    key: "baseFetch",
    value: function () {
      var _baseFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input, init) {
        var options,
            response,
            refreshResponse,
            refreshResponseJson,
            error,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {
                  enablePersistendAuth: true
                };
                _context.next = 3;
                return fetch(this.url + input, _objectSpread(_objectSpread({}, init), {}, {
                  headers: _objectSpread(_objectSpread({}, init === null || init === void 0 ? void 0 : init.headers), this.KeyManager.prepareAuthHeaders(init === null || init === void 0 ? void 0 : init.headers))
                }));

              case 3:
                response = _context.sent;

                if (options !== null && options !== void 0 && options.enablePersistendAuth) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", response);

              case 6:
                if (!(response.status === 422)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 9;
                return fetch(this.url + '/auth/refresh', {
                  method: 'POST',
                  headers: this.KeyManager.prepareAuthHeaders({}, true)
                });

              case 9:
                refreshResponse = _context.sent;

                if (!(refreshResponse.status === 401)) {
                  _context.next = 12;
                  break;
                }

                throw new Error('refresh failed');

              case 12:
                if (!(refreshResponse.status === 200)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 15;
                return refreshResponse.json();

              case 15:
                refreshResponseJson = _context.sent;
                this.KeyManager.setAccessToken(refreshResponseJson.access_token);
                _context.next = 19;
                return this.baseFetch(input, init, options);

              case 19:
                return _context.abrupt("return", _context.sent);

              case 20:
                if (!(response.status !== 200)) {
                  _context.next = 25;
                  break;
                }

                _context.next = 23;
                return response.json();

              case 23:
                error = _context.sent;
                throw new Error(error.detail);

              case 25:
                return _context.abrupt("return", response);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function baseFetch(_x, _x2) {
        return _baseFetch.apply(this, arguments);
      }

      return baseFetch;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
        var email, password, body, response, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                email = _ref.email, password = _ref.password;
                body = JSON.stringify({
                  email: email,
                  password: password
                });
                _context2.next = 4;
                return this.baseFetch('/auth/login', {
                  method: 'POST',
                  body: body,
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                  }
                });

              case 4:
                response = _context2.sent;
                _context2.next = 7;
                return response.json();

              case 7:
                data = _context2.sent;
                this.KeyManager.setAccessToken(data.access_token);
                this.KeyManager.setRefreshToken(data.refresh_token);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function login(_x3) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.baseFetch('/auth/logout', {
                  method: 'DELETE'
                });

              case 2:
                this.KeyManager.clearTokens();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "getMe",
    value: function () {
      var _getMe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response, error;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.baseFetch('/users/me', {
                  method: 'GET'
                });

              case 2:
                response = _context4.sent;

                if (!(response.status !== 200)) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 6;
                return response.json();

              case 6:
                error = _context4.sent;
                throw new Error(error.detail);

              case 8:
                _context4.next = 10;
                return response.json();

              case 10:
                return _context4.abrupt("return", _context4.sent);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getMe() {
        return _getMe.apply(this, arguments);
      }

      return getMe;
    }()
  }, {
    key: "publishProject",
    value: function () {
      var _publishProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, migrationUrl) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.baseFetch("/projects/".concat(projectId, "/publish?migration_url=").concat(migrationUrl));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function publishProject(_x4, _x5) {
        return _publishProject.apply(this, arguments);
      }

      return publishProject;
    }()
  }, {
    key: "createSheet",
    value: function () {
      var _createSheet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(args) {
        var projectId, sheetsToken, sheetName, file, url, formData, text, res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                projectId = args.projectId, sheetsToken = args.sheetsToken, sheetName = args.sheetName, file = args.file;
                url = "/projects/".concat(projectId, "/sheets?sheet_name=").concat(sheetName);

                if (sheetsToken) {
                  url += "&sheets_token=".concat(sheetsToken);
                }

                formData = new FormData();
                _context6.next = 6;
                return file.text();

              case 6:
                text = _context6.sent;
                formData.append('in_file', text, file.name);
                _context6.next = 10;
                return this.baseFetch(url, {
                  method: 'POST',
                  body: formData
                });

              case 10:
                res = _context6.sent;

                if (!(res.status !== 200)) {
                  _context6.next = 17;
                  break;
                }

                _context6.t0 = Error;
                _context6.next = 15;
                return res.text();

              case 15:
                _context6.t1 = _context6.sent;
                throw new _context6.t0(_context6.t1);

              case 17:
                _context6.next = 19;
                return res.json();

              case 19:
                return _context6.abrupt("return", _context6.sent);

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createSheet(_x6) {
        return _createSheet.apply(this, arguments);
      }

      return createSheet;
    }()
  }, {
    key: "getSheet",
    value: function () {
      var _getSheet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(args) {
        var projectId, sheetName, sheetsToken, url, res, blob, filename, filenameRegex, filenameMatch;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                projectId = args.projectId, sheetName = args.sheetName, sheetsToken = args.sheetsToken;
                url = "/projects/".concat(projectId, "/sheets/").concat(sheetName);

                if (sheetsToken) {
                  url += "?sheets_token=".concat(sheetsToken);
                }

                _context7.next = 5;
                return this.baseFetch(url);

              case 5:
                res = _context7.sent;

                if (!(res.status !== 200)) {
                  _context7.next = 12;
                  break;
                }

                _context7.t0 = Error;
                _context7.next = 10;
                return res.text();

              case 10:
                _context7.t1 = _context7.sent;
                throw new _context7.t0(_context7.t1);

              case 12:
                _context7.next = 14;
                return res.blob();

              case 14:
                blob = _context7.sent;
                filename = res.headers.get('content-disposition');

                if (!filename) {
                  _context7.next = 21;
                  break;
                }

                filenameRegex = /filename="(.*)"/;
                filenameMatch = filenameRegex.exec(filename);

                if (!filenameMatch) {
                  _context7.next = 21;
                  break;
                }

                return _context7.abrupt("return", new File([blob], filenameMatch[1]));

              case 21:
                return _context7.abrupt("return", new File([blob], "".concat(sheetName, ".sheet")));

              case 22:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getSheet(_x7) {
        return _getSheet.apply(this, arguments);
      }

      return getSheet;
    }()
  }, {
    key: "getSheets",
    value: function () {
      var _getSheets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(args) {
        var projectId, sheetsToken, url, res;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                projectId = args.projectId, sheetsToken = args.sheetsToken;
                url = "/projects/".concat(projectId, "/sheets");

                if (sheetsToken) {
                  url += "?sheets_token=".concat(sheetsToken);
                }

                _context8.next = 5;
                return this.baseFetch(url);

              case 5:
                res = _context8.sent;

                if (!(res.status !== 200)) {
                  _context8.next = 12;
                  break;
                }

                _context8.t0 = Error;
                _context8.next = 10;
                return res.text();

              case 10:
                _context8.t1 = _context8.sent;
                throw new _context8.t0(_context8.t1);

              case 12:
                _context8.next = 14;
                return res.json();

              case 14:
                return _context8.abrupt("return", _context8.sent);

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getSheets(_x8) {
        return _getSheets.apply(this, arguments);
      }

      return getSheets;
    }()
  }, {
    key: "updateSheet",
    value: function () {
      var _updateSheet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(args) {
        var projectId, sheetsToken, sheetName, file, url, text, formData, res;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                projectId = args.projectId, sheetsToken = args.sheetsToken, sheetName = args.sheetName, file = args.file;
                url = "/projects/".concat(projectId, "/sheets/").concat(sheetName);

                if (sheetsToken) {
                  url += "?sheets_token=".concat(sheetsToken);
                }

                _context9.next = 5;
                return file.text();

              case 5:
                text = _context9.sent;
                formData = new FormData();
                formData.append('in_file', text, file.name);
                _context9.next = 10;
                return this.baseFetch(url, {
                  method: 'PATCH',
                  body: formData
                });

              case 10:
                res = _context9.sent;

                if (!(res.status !== 200)) {
                  _context9.next = 17;
                  break;
                }

                _context9.t0 = Error;
                _context9.next = 15;
                return res.text();

              case 15:
                _context9.t1 = _context9.sent;
                throw new _context9.t0(_context9.t1);

              case 17:
                return _context9.abrupt("return");

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function updateSheet(_x9) {
        return _updateSheet.apply(this, arguments);
      }

      return updateSheet;
    }()
  }, {
    key: "deleteSheet",
    value: function () {
      var _deleteSheet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(args) {
        var projectId, sheetName, sheetsToken, url, res;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                projectId = args.projectId, sheetName = args.sheetName, sheetsToken = args.sheetsToken;
                url = "/projects/".concat(projectId, "/sheets/").concat(sheetName);

                if (sheetsToken) {
                  url += "?sheets_token=".concat(sheetsToken);
                }

                _context10.next = 5;
                return this.baseFetch(url, {
                  method: 'DELETE'
                });

              case 5:
                res = _context10.sent;

                if (!(res.status !== 200)) {
                  _context10.next = 12;
                  break;
                }

                _context10.t0 = Error;
                _context10.next = 10;
                return res.text();

              case 10:
                _context10.t1 = _context10.sent;
                throw new _context10.t0(_context10.t1);

              case 12:
                return _context10.abrupt("return");

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function deleteSheet(_x10) {
        return _deleteSheet.apply(this, arguments);
      }

      return deleteSheet;
    }()
  }]);

  return SnekApi;
}();